// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VuePaginate from 'vue-paginate';
import VeeValidate from 'vee-validate';
import { sync } from 'vuex-router-sync';
import App from './App';
import router from './router';
import store from './store';

require('./assets/scss/main.scss');

Vue.config.productionTip = false;

Vue.use(VuePaginate);
Vue.use(VeeValidate);

sync(store, router);

/* eslint-disable-next-line */
export const eventBus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js